<template>
    <!-- 手机提现明细 -->
    <ZhaiHead></ZhaiHead>

    <div class="container-fluid zhu px-0">
        <!-- 顶部栏 -->
        <div class="row shengse">
            <div class="dixian px-4 py-2 top-bar">
                <div class="promo-title" @click="goBack">
                    <i class="fa fa-bullhorn"></i>推广中心
                </div>

                <div class="top-center-title" @click="goWithdrawalDetails">提现明细</div>

                <div class="top-right" @click="goMyWallet">
                    钱包 <span class="arrow">›</span>
                </div>
            </div>
        </div>

        <!-- 内容区 -->
        <div class="content-area">
            <!-- 加载中骨架屏 -->
            <div v-if="loading" class="skeleton-wrap">
                <div class="skeleton-card" v-for="i in 6" :key="i">
                    <div class="skeleton-row">
                        <div class="skeleton-block w-40"></div>
                        <div class="skeleton-block w-20"></div>
                    </div>
                    <div class="skeleton-row">
                        <div class="skeleton-block w-55"></div>
                        <div class="skeleton-block w-25"></div>
                    </div>
                    <div class="skeleton-row">
                        <div class="skeleton-block w-70"></div>
                    </div>
                </div>
            </div>

            <!-- 错误态 -->
            <div v-else-if="error" class="state-wrap">
                <div class="state-title">加载失败</div>
                <div class="state-desc">{{ error }}</div>
                <button class="btn-retry" @click="reload">点击重试</button>
            </div>

            <!-- 空状态 -->
            <div v-else-if="records.length === 0" class="empty-line">
                <span class="line"></span>
                <span class="text">我是有底线的</span>
                <span class="line"></span>
            </div>

            <!-- 列表 -->
            <div v-else class="list-wrap" ref="listWrap">
                <!-- 明细卡片 -->
                <div class="record-card" v-for="item in records" :key="item.id">
                    <div class="record-top">
                        <div class="record-left">
                            <div class="record-title">
                                提现
                                <span class="badge" :class="statusClass(item.status)">
                  {{ statusText(item.status) }}
                </span>
                            </div>
                            <div class="record-sub">到账方式：{{ item.channel || "—" }}</div>
                        </div>

                        <div class="record-right">
                            <div class="money neg">-{{ formatMoney(item.amount) }}</div>
                            <div class="time">{{ item.time || "—" }}</div>
                        </div>
                    </div>

                    <div class="divider"></div>

                    <div class="record-bottom">
                        <div class="meta">
                            <span class="label">单号</span>
                            <span class="value">{{ item.orderNo || "—" }}</span>
                        </div>

                        <div class="meta">
                            <span class="label">备注</span>
                            <span class="value">{{ item.remark || "—" }}</span>
                        </div>
                    </div>
                </div>

                <!-- ✅ 总页数 > 1 才展示分页器 -->
                <div class="pager-wrap" v-if="totalPages > 1">
                    <div class="pager">
                        <!-- 上一页 -->
                        <button
                                class="pager-btn"
                                :disabled="page === 1 || pageChanging"
                                @click="goPage(page - 1)"
                        >
                            «
                        </button>

                        <!-- 首页 -->
                        <button
                                class="pager-btn"
                                :class="{ active: page === 1 }"
                                :disabled="pageChanging"
                                @click="goPage(1)"
                        >
                            1
                        </button>

                        <!-- ✅ 动态显示当前页（如果当前页在中间） -->
                        <template v-if="totalPages >= 3">
                            <template v-if="page > 1 && page < totalPages">
                                <button class="pager-btn dots" disabled>…</button>

                                <!-- 当前页 -->
                                <button class="pager-btn active" disabled>
                                    {{ page }}
                                </button>

                                <button class="pager-btn dots" disabled>…</button>
                            </template>

                            <!-- 首页或末页：只显示一个 … -->
                            <template v-else>
                                <button class="pager-btn dots" disabled>…</button>
                            </template>
                        </template>

                        <!-- 末页 -->
                        <button
                                class="pager-btn"
                                :class="{ active: page === totalPages }"
                                :disabled="pageChanging"
                                @click="goPage(totalPages)"
                        >
                            {{ totalPages }}
                        </button>

                        <!-- 下一页 -->
                        <button
                                class="pager-btn"
                                :disabled="page === totalPages || pageChanging"
                                @click="goPage(page + 1)"
                        >
                            »
                        </button>
                    </div>

                    <div class="pager-loading" v-if="pageChanging">加载中…</div>
                </div>
            </div>
        </div>
    </div>

    <ZhaiFoot></ZhaiFoot>
</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import http from "@/utils/http";

    export default {
        name: "MWithdrawalDetails",
        components: { ZhaiHead, ZhaiFoot },

        data() {
            return {
                API_WITHDRAW_LIST: "/platform/withdraw/myList",

                // 状态
                loading: true,
                pageChanging: false,
                error: "",

                // 列表数据（渲染用）
                records: [],

                // 分页
                page: 1,
                pageSize: 6,
                total: 0,

                // ✅ 与 PC 对齐：可选的 userId
                currentUserId: null,

                // ✅（手机端目前没有筛选 UI，但按 PC 逻辑保留能力：默认“全部”）
                statusFilter: "", // "" / "0" / "1" / "2" / "3"
            };
        },

        computed: {
            totalPages() {
                const t = Number(this.total || 0);
                const s = Number(this.pageSize || 10);
                return Math.max(1, Math.ceil(t / s));
            },
        },

        // ✅ 与 PC 对齐：路由守卫
        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        async mounted() {
            // ✅ 与 PC 对齐：mounted 再兜一次
            const token = localStorage.getItem("token");
            if (!token) {
                if (this.$router) this.$router.replace("/login");
                else window.location.href = "/login";
                return;
            }

            this.currentUserId = this.resolveUserIdSafe();
            await this.fetchList(true);
        },

        methods: {
            // ================== 跳转（保留你的） ==================
            goBack() {
                if (this.$router) this.$router.push("/Promotion");
                else window.location.href = "/Promotion";
            },
            goMyWallet() {
                if (this.$router) this.$router.push("/MyWallet");
                else window.location.href = "/MyWallet";
            },
            goWithdrawalDetails() {
                if (this.$router) this.$router.push("/WithdrawalDetails");
                else window.location.href = "/WithdrawalDetails";
            },

            // ================== 更稳的 userId 获取（同 PC） ==================
            resolveUserIdSafe() {
                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }
                return null;
            },

            // ================== 登录失效识别（同余额明细那套） ==================
            isAuthExpired(err, json) {
                const code = err?.response?.status;
                if (code === 401 || code === 403) return true;

                const s = json?.status;
                if (s === 401 || s === 403 || s === -1) return true;

                const msg = String(json?.msg || err?.message || "");
                if (/token|登录|未登录|过期|失效|unauthorized|forbidden/i.test(msg)) return true;

                return false;
            },

            redirectToLogin() {
                if (this.$router) this.$router.replace("/login");
                else window.location.href = "/login";
            },

            // ================== 工具：到账方式展示（同 PC） ==================
            methodText(m) {
                const map = { 1: "USDT", 2: "支付宝", 3: "银行卡" };
                return map[m] || "—";
            },

            // ================== 工具：金额格式（同 PC） ==================
            formatMoney(v) {
                const n = Number(v || 0);
                return n.toFixed(2);
            },

            // ================== 状态展示（同 PC） ==================
            statusText(s) {
                const map = { 0: "待审核", 1: "处理中", 2: "已到账", 3: "失败" };
                return map[s] || "未知";
            },
            statusClass(s) {
                return {
                    pending: s === 0,
                    doing: s === 1,
                    success: s === 2,
                    fail: s === 3,
                };
            },

            // ================== 核心：拉取提现列表（对齐 PC /platform/withdraw/myList） ==================
            async fetchList(reset = false) {
                try {
                    if (reset) {
                        this.loading = true;
                        this.error = "";
                    } else {
                        this.pageChanging = true;
                        this.error = "";
                    }

                    const params = {
                        page: this.page,
                        pageSize: this.pageSize,
                        status: this.statusFilter === "" ? undefined : Number(this.statusFilter),
                    };

                    // ✅ 有 userId 就传（同 PC）
                    if (this.currentUserId) params.userId = this.currentUserId;

                    const res = await http.get(this.API_WITHDRAW_LIST, params);
                    const json = res && res.data ? res.data : null;

                    // ✅ 未登录：直接跳登录
                    if (this.isAuthExpired(null, json)) {
                        this.redirectToLogin();
                        return;
                    }

                    if (!json || Number(json.status) !== 1) {
                        const msg = (json && json.msg) || "加载失败";
                        if (/未登录|登录/i.test(msg)) {
                            this.redirectToLogin();
                            return;
                        }
                        throw new Error(msg);
                    }

                    const data = json.data || {};
                    const list = Array.isArray(data.list) ? data.list : [];

                    // ✅ 字段映射（同 PC）
                    this.records = list.map((x) => {
                        const amountCent = Number(x.amountCent || 0);
                        const amount = amountCent / 100;

                        return {
                            id: x.id,
                            status: x.status,
                            orderNo: x.orderNo,
                            remark: x.remark,

                            amount, // template: formatMoney(item.amount)
                            time: x.createdAt, // template: item.time
                            channel: this.methodText(x.method), // template: item.channel
                        };
                    });

                    this.total = Number(data.total || 0);

                    // ✅ 防御：页码越界自动纠正（同 PC）
                    const tp = this.totalPages;
                    if (this.page > tp) {
                        this.page = tp;
                        await this.fetchList(false);
                    }

                    // ✅ 回到顶部（保持你原体验）
                    this.$nextTick(() => {
                        const el = this.$refs.listWrap;
                        if (el) el.scrollTop = 0;
                    });
                } catch (e) {
                    if (this.isAuthExpired(e, null)) {
                        this.redirectToLogin();
                        return;
                    }
                    this.error = e && e.message ? e.message : "网络异常，请稍后再试";
                } finally {
                    this.loading = false;
                    this.pageChanging = false;
                }
            },

            // ================== 分页 ==================
            async goPage(p) {
                const pageNum = Number(p);
                if (!pageNum || pageNum < 1 || pageNum > this.totalPages) return;
                if (pageNum === this.page) return;
                if (this.loading || this.pageChanging) return;

                this.page = pageNum;
                await this.fetchList(false);
            },

            // ================== 刷新 ==================
            reload() {
                this.page = 1;
                this.fetchList(true);
            },
        },
    };
</script>

<style scoped>
    .fa {
        margin-right: 6px;
    }

    /* 页面容器 */
    .zhu {
        margin-top: 80px;
        height: calc(100vh - 80px);
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    /* 顶部栏三列布局 */
    .top-bar {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
    }
    .top-center-title {
        justify-self: center;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        color: #00c26f;
    }
    .top-right {
        justify-self: end;
        font-size: 14px;
        color: #00c26f;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .top-right:active {
        opacity: 0.7;
    }
    .promo-title {
        cursor: pointer;
        user-select: none;
        font-size: 16px;
        color: #333;
    }
    .promo-title:active {
        opacity: 0.7;
    }
    .arrow {
        font-size: 22px;
        color: #c9c9c9;
        margin-right: 0;
    }

    /* 内容区 */
    .content-area {
        flex: 1;
        background: #fff;
        overflow: hidden;
    }

    /* 空状态 */
    .empty-line {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 24px;
        color: #9b9b9b;
        font-size: 16px;
    }
    .empty-line .line {
        width: 120px;
        height: 1px;
        background: #e9e9e9;
        margin: 0 14px;
        transform: translateY(12px);
    }
    .empty-line .text {
        white-space: nowrap;
    }

    /* 错误态 */
    .state-wrap {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding-top: 40px;
        color: #666;
    }
    .state-title {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 8px;
        color: #333;
    }
    .state-desc {
        font-size: 14px;
        margin-bottom: 16px;
    }
    .btn-retry {
        border: 0;
        padding: 10px 16px;
        border-radius: 10px;
        background: #00c26f;
        color: #fff;
        font-size: 14px;
    }
    .btn-retry:active {
        opacity: 0.85;
    }

    /* 列表容器 */
    .list-wrap {
        height: 100%;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding: 12px 12px 18px;
    }

    /* 明细卡片 */
    .record-card {
        background: #fff;
        border: 1px solid #f2f2f2;
        border-radius: 12px;
        padding: 12px;
        margin-bottom: 10px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
    }
    .record-top {
        display: flex;
        justify-content: space-between;
        gap: 12px;
    }
    .record-left {
        flex: 1;
        min-width: 0;
    }
    .record-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 15px;
        font-weight: 700;
        color: #222;
    }
    .record-sub {
        margin-top: 6px;
        font-size: 12px;
        color: #8b8b8b;
    }
    .record-right {
        text-align: right;
        flex-shrink: 0;
    }
    .money {
        font-size: 18px;
        font-weight: 800;
        color: #222;
        line-height: 1.2;
    }
    .money.neg {
        color: #ff4d4f;
    }
    .time {
        margin-top: 6px;
        font-size: 12px;
        color: #9a9a9a;
    }
    .divider {
        height: 1px;
        background: #f0f0f0;
        margin: 10px 0;
    }
    .record-bottom .meta {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding: 6px 0;
        font-size: 13px;
    }
    .record-bottom .label {
        color: #8a8a8a;
        flex-shrink: 0;
    }
    .record-bottom .value {
        color: #333;
        text-align: right;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /* 状态徽标 */
    .badge {
        font-size: 12px;
        font-weight: 700;
        padding: 3px 8px;
        border-radius: 999px;
        border: 1px solid transparent;
    }
    .badge.pending {
        color: #d48806;
        background: #fff7e6;
        border-color: #ffe7ba;
    }
    .badge.doing {
        color: #0958d9;
        background: #e6f4ff;
        border-color: #bae0ff;
    }
    .badge.success {
        color: #1f8a4c;
        background: #e9fff1;
        border-color: #b7eb8f;
    }
    .badge.fail {
        color: #cf1322;
        background: #fff1f0;
        border-color: #ffccc7;
    }

    /* 骨架屏 */
    .skeleton-wrap {
        padding: 12px;
    }
    .skeleton-card {
        border: 1px solid #f2f2f2;
        border-radius: 12px;
        padding: 12px;
        margin-bottom: 10px;
        background: #fff;
    }
    .skeleton-row {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        margin-bottom: 10px;
    }
    .skeleton-block {
        height: 12px;
        border-radius: 8px;
        background: linear-gradient(90deg, #f3f3f3 25%, #ececec 37%, #f3f3f3 63%);
        background-size: 400% 100%;
        animation: shimmer 1.2s ease-in-out infinite;
    }
    .w-20 { width: 20%; }
    .w-25 { width: 25%; }
    .w-40 { width: 40%; }
    .w-55 { width: 55%; }
    .w-70 { width: 70%; }
    @keyframes shimmer {
        0% { background-position: 100% 0; }
        100% { background-position: 0 0; }
    }

    /* 分页器 */
    .pager-wrap {
        padding: 14px 0 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .pager {
        display: inline-flex;
        align-items: center;
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid #e6e6e6;
        background: #fff;
    }
    .pager-btn {
        min-width: 34px;
        height: 32px;
        padding: 0 10px;
        border: 0;
        border-right: 1px solid #e6e6e6;
        background: #fff;
        color: #333;
        font-size: 18px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
        user-select: none;
    }
    .pager-btn:last-child {
        border-right: 0;
    }
    .pager-btn:disabled {
        opacity: 0.45;
        cursor: not-allowed;
    }
    .pager-btn.active {
        color: #00c26f;
        font-weight: 800;
        background: #f3fff8;
    }
    .pager-btn.dots {
        cursor: default;
        font-weight: 700;
    }
    .pager-btn:active:not(:disabled):not(.dots) {
        opacity: 0.75;
    }
    .pager-loading {
        margin-top: 8px;
        font-size: 12px;
        color: #9a9a9a;
    }
</style>
